import { render } from "./VabeneAddCoupon.vue?vue&type=template&id=5f4edf04&ts=true"
import script from "./VabeneAddCoupon.vue?vue&type=script&lang=ts"
export * from "./VabeneAddCoupon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__